import { render, staticRenderFns } from "./VineyardSimpleWaterMetricTable.vue?vue&type=template&id=7c3e2a5a&scoped=true&"
import script from "./VineyardSimpleWaterMetricTable.vue?vue&type=script&lang=js&"
export * from "./VineyardSimpleWaterMetricTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3e2a5a",
  null
  
)

export default component.exports